(function () {
  'use strict';

  function getGlobalConfig() {
    return document.querySelector('[data-prevente-global-config]');
  }

  function parseEditableDeadline(config) {
    if (!config) return null;
    var rawDate = (config.dataset.deadlineDate || '').trim();
    var match = rawDate.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) {
      var isoMatch = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) match = [isoMatch[0], isoMatch[3], isoMatch[2], isoMatch[1]];
    }
    if (!match) return null;
    var hour = String(config.dataset.deadlineHour || '0').padStart(2, '0');
    var minute = String(config.dataset.deadlineMinute || '0').padStart(2, '0');
    var offset = config.dataset.deadlineOffset || '+02:00';
    var parsed = new Date(match[3] + '-' + match[2] + '-' + match[1] + 'T' + hour + ':' + minute + ':00' + offset);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  function initCountdown(root) {
    var globalConfig = getGlobalConfig();
    var raw = root.dataset.deadline;
    var deadline = raw ? new Date(raw) : parseEditableDeadline(globalConfig);
    if (!deadline || Number.isNaN(deadline.getTime())) return;
    var expiredMode = root.dataset.expiredMode || (globalConfig && globalConfig.dataset.expiredMode) || 'disable';
    var expiredText = root.dataset.expiredText || (globalConfig && globalConfig.dataset.expiredText) || 'Offre terminée';
    var timer;

    function splitCalendarDifference(now, end) {
      var cursor = new Date(now.getTime());
      var months = 0;
      while (months < 1200) {
        var next = new Date(cursor.getTime());
        next.setMonth(next.getMonth() + 1);
        if (next > end) break;
        cursor = next;
        months += 1;
      }
      var remaining = Math.max(0, end.getTime() - cursor.getTime());
      return {
        months: months,
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining % 86400000) / 3600000),
        minutes: Math.floor((remaining % 3600000) / 60000),
        seconds: Math.floor((remaining % 60000) / 1000)
      };
    }

    function render() {
      var diff = Math.max(0, deadline.getTime() - Date.now());
      var values = splitCalendarDifference(new Date(), deadline);
      Object.keys(values).forEach(function (key) {
        root.querySelectorAll('[data-countdown-' + key + ']').forEach(function (node) {
          node.textContent = String(values[key]).padStart(2, '0');
        });
      });
      document.querySelectorAll('[data-prevente-top-timer]').forEach(function (node) {
        node.textContent = values.months + (node.dataset.monthLabel || 'm') + ' ' + values.days + (node.dataset.dayLabel || 'j') + ' ' + String(values.hours).padStart(2, '0') + (node.dataset.hourLabel || 'h') + ' ' + String(values.minutes).padStart(2, '0') + (node.dataset.minuteLabel || 'm');
      });
      if (diff === 0) {
        clearInterval(timer);
        document.querySelectorAll('[data-prevente-expiry-label]').forEach(function (node) { node.textContent = expiredText; });
        if (expiredMode === 'disable') {
          document.querySelectorAll('[data-prevente-buy]').forEach(function (button) {
            button.disabled = true;
            button.textContent = expiredText;
          });
        }
      }
    }
    render();
    timer = window.setInterval(render, 1000);
  }

  function initFaq() {
    document.querySelectorAll('[data-prevente-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.faq-item');
        var answer = item.querySelector('.faq-a');
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        answer.hidden = open;
        item.classList.toggle('open', !open);
      });
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (node) { node.classList.add('visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    nodes.forEach(function (node) { observer.observe(node); });
  }

  function initPurchase() {
    document.querySelectorAll('[data-prevente-buy-proxy]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var purchaseButton = document.querySelector('.offer-cta-btn[data-prevente-buy]');
        if (purchaseButton && !purchaseButton.disabled) purchaseButton.click();
      });
    });
    document.querySelectorAll('[data-prevente-buy]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var variantId = Number(button.dataset.variantId);
        var sellingPlanId = Number(button.dataset.sellingPlanId);
        var error = document.querySelector('[data-prevente-purchase-error]');
        if (!variantId || !sellingPlanId) {
          if (error) { error.hidden = false; error.textContent = button.dataset.configError || 'La précommande est temporairement indisponible.'; }
          return;
        }
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (error) error.hidden = true;
        try {
          var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, selling_plan: sellingPlanId, properties: { '_source': 'prevente_oralys' } }] })
          });
          var result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || button.dataset.cartError || 'Impossible d’ajouter la précommande.');
          window.location.assign(window.Shopify.routes.root + 'cart');
        } catch (err) {
          if (error) { error.hidden = false; error.textContent = err.message; }
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    });
  }

  function initSticky() {
    var sticky = document.querySelector('[data-prevente-sticky]');
    var hero = document.querySelector('.hero');
    if (!sticky || !hero || !('IntersectionObserver' in window)) return;
    var purchaseButton = document.querySelector('.offer-cta-btn[data-prevente-buy]');
    var footer = document.querySelector('[data-prevente-footer]');
    var state = { hero: true, purchase: false, footer: false };
    function renderSticky() {
      var visible = !state.hero && !state.purchase && !state.footer;
      sticky.classList.toggle('visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
    }
    new IntersectionObserver(function (entries) {
      state.hero = entries[0].isIntersecting;
      renderSticky();
    }, { threshold: 0.1 }).observe(hero);
    if (purchaseButton) {
      new IntersectionObserver(function (entries) {
        state.purchase = entries[0].isIntersecting;
        renderSticky();
      }, { threshold: 0.15 }).observe(purchaseButton);
    }
    if (footer) {
      new IntersectionObserver(function (entries) {
        state.footer = entries[0].isIntersecting;
        renderSticky();
      }, { threshold: 0 }).observe(footer);
    }
    renderSticky();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-prevente-countdown]').forEach(initCountdown);
    initFaq(); initReveal(); initPurchase(); initSticky();
  });
})();
